<template>
  <div>

    <div v-if="pd">
      <div class="mt-10 title1 ">Protect your biggest asset with mortgage protection</div>

      <div class="mt-3">Getting a mortgage is a big, long-term financial commitment. As a client of Premiere, you are entitled to receive a no-obligation Mortgage Payment Protection quote on affordable life, disability, critical illness, and job loss insurance.</div>

      <div class="mt-3">Protect you and your family from financial hardship caused by <b>unexpected events</b>.</div>

      <div class="row mt-3">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <div class="d-flex ">
            <div><img src="/images/cumis/b-f-1.fw.png" /></div>
            <div class="pl-2">
              <div><b>48% of Canadians</b></div>
              <div class="text1">say they live within $200 of not being able to cover their monthly bills<sup>1</sup></div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4">
          <div class="d-flex">
            <div><img src="/images/cumis/b-f-2.fw.png" /></div>
            <div class="pl-2">
              <div><b>1 in 3 people</b></div>
              <div class="text1">will be disabled for 90 days or more at least once before they reach the age of 65<sup>2</sup></div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4">
          <div class="d-flex">
            <div><img src="/images/cumis/b-f-3.fw.png" /></div>
            <div class="pl-2">
              <div><b>1 in 2 Canadians</b></div>
              <div class="text1">will develop cancer in their lifetime<sup>3</sup></div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">Mortgage Payment Protection is optional and comes with a <b>30-day money back guarantee</b>.</div>

      <div class="mt-3">A Premiere Life Insurance Agent is available to review your overall insurance needs and provide quotes for <b>customizable Mortgage Payment Protection</b> options.</div>


      <div class="mt-6">
        <table>
          <thead>
          <tr>
            <th class="applicantName">{{pd.Applicants[0].ApplicantName}}</th>
            <th class="applicantName" v-if="pd.Applicants.length>1">{{pd.Applicants[1].ApplicantName}}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="text-center">
              <input class="radioButton" :name="pd.Applicants[0].ApplicantName" v-model="pd.Applicants[0].answer" :value="true" type="radio" @change="showError = false" />
            </td>
            <td  v-if="pd.Applicants.length>1" class="text-center">
              <input class="radioButton" :name="pd.Applicants[1].ApplicantName" v-model="pd.Applicants[1].answer" :value="true" type="radio" @change="showError = false" />
            </td>
            <td>
              <div style="width: 100%; "><b>Yes!</b> I/We would like a no-obligation quote for Mortgage Payment Protection.</div>
              <div style="font-size: 0.85em;" class="text-muted">
                I/We understand that I/We will receive a call from a Premiere Insurance Representative to review my Mortgage Payment Protection options and that a Premiere Life Insurance Agent is available to review my overall insurance needs.
                <i>Quotes will be sent to your email upon mortgage approval.</i>
              </div>
            </td>
          </tr>
          <tr>
            <td class="text-center pt-3">
              <input class="radioButton" :name="pd.Applicants[0].ApplicantName" v-model="pd.Applicants[0].answer" :value="false" type="radio" @change="showError = false" />
            </td>
            <td  v-if="pd.Applicants.length>1" class="text-center pt-3">
              <input class="radioButton" :name="pd.Applicants[1].ApplicantName" v-model="pd.Applicants[1].answer" :value="false" type="radio" @change="showError = false" />
            </td>
            <td class="pt-3">
              <div style="width: 100%; "><b>No.</b> I/We am not interested.</div>
              <div style="font-size: 0.85em;" class="text-muted">By selecting "Not interested", I/We acknowledge that the mortgage will not be covered by optional Mortgage Payment Protection. <i>Confirmation of waiver will be sent to your email address.</i>

              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-if="showError" class="d-flex justify-space-around mt-12 mb-12">
        <span style="color: red;">
          {{$t('errors.CoopYesNo')}}
        </span>
      </div>
      <div class="d-flex justify-space-around mt-12 mb-12">
        <v-btn color="primary" @click="onSave">Submit</v-btn>
      </div>
    </div>
    <div v-else>
      <div v-if="!loading" style="width: 500px;margin:0 auto;padding-top: 100px;" class="text-center" v-html="$t('errors.CoopLinkActioned')"></div>
    </div>

    <div v-if="loading" class="loading">Loading&#8230;</div>
  </div>
</template>
<script>
import dataSvc from "@/services/dataService";
import { EventBus } from "@/services/eventBus";

export default {
  data(){
    return{
      sessionKey:   this.$route.params.id,
      loading: true,
      showError: false,  
      pd: null
    }
  },
  async created() {
    await this.load();
  },
  methods:{
    async load(){
      let postData={
        SessionKey: this.sessionKey
      };
      let rv  = await dataSvc.post('api/CU_Load', postData);
      this.loading=false;
      if(rv ){
        if( rv.ClientCache.MongoID) {
          this.pd = rv.ClientCache;
          EventBus.$emit('flagChanged', true);
        }
      }
    },
    async onSave(){
      let postData={
        SessionKey: this.sessionKey,
        Primary: null,
        Secondary :null
      };
      if(this.pd.Applicants.length>1){
        if(this.pd.Applicants[0].answer == undefined || this.pd.Applicants[0].answer == null || this.pd.Applicants[1].answer == undefined || this.pd.Applicants[1].answer == null){
          this.showError = true;
          return;
        }
      }
      else{
        if(this.pd.Applicants[0].answer == undefined || this.pd.Applicants[0].answer == null){
          this.showError = true;
          return;
        }
      }
      
       
      postData.Primary =  this.pd.Applicants[0].answer;
      if(this.pd.Applicants.length>1)
        postData.Secondary =  this.pd.Applicants[1].answer;
      this.loading=true;
      let rv = await dataSvc.post('api/CU_SAVE', postData);
      this.loading=false;

     if(this.pd.Applicants.length>1){
      if(postData.Primary && postData.Secondary)
        this.$router.push('/cooperators/thankyou/1');
      else if( postData.Primary || postData.Secondary)
        this.$router.push('/cooperators/thankyou/2');
      else
        this.$router.push('/cooperators/thankyou/3');
     } else {
       if(postData.Primary ){
         this.$router.push('/cooperators/thankyou/1');
       } else {
         this.$router.push('/cooperators/thankyou/3');
       }
     }

    }
  }
}
</script>

<style scoped>
.applicantName{
  min-width: 140px;
  font-size: 1.1em;
  padding: 0 10px 0 10px;
  white-space: nowrap;
}
.title1{
  font-family: Roboto;
  color: #006EB3;
}
.text1{
  color: #068ee3;
}
@media screen and (min-width: 601px){
  .title1{ font-size: 2em; font-weight: 500;}
}
@media screen and (max-width: 600px){
  .title1{ font-size: 1.2em}

}

.radioButton{
  cursor: pointer;
  -ms-transform: scale(2); /* IE 9 */
  -webkit-transform: scale(2); /* Chrome, Safari, Opera */
  transform: scale(2);
}

</style>